"use client";

import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import { Theme, ThemeProvider } from "@template/theme";

const checkIfColorIsDark = (colorHex: string) => {
  // Convert hex to RGB
  let hex = colorHex.replace("#", "");
  let r = parseInt(hex.substr(0, 2), 16);
  let g = parseInt(hex.substr(2, 2), 16);
  let b = parseInt(hex.substr(4, 2), 16);

  // Calculate relative luminance (Y)
  // Formula: Y = 0.2126*R + 0.7152*G + 0.0722*B
  let relativeLuminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // Check color brightness, return true if dark
  return relativeLuminance < 128;
};

export const checkIfDarkMode = (
  color: string,
  algorithm: Theme["color_algorithm"]
) => {
  switch (algorithm) {
    case "light":
      return false;
    case "dark":
      return true;
    case "auto":
    default:
      return checkIfColorIsDark(color);
  }
};

export const EditorThemeProvider = ({ children }: { children?: any }) => {
  const editorTheme = useTypedSelector((state) => state.admin.theme);
  const siteTheme = useTypedSelector((state) => state.store.theme);

  const storeTheme = editorTheme.colors ? editorTheme : siteTheme;

  if (!storeTheme.colors) return;

  return (
    <ThemeProvider
      theme={storeTheme}
      type="import"
    >
      {children}
    </ThemeProvider>
  );
};
